// extracted by mini-css-extract-plugin
module.exports = {"header":"_10157","back":"_12784","shareIcon":"_9323"};